<div class="operacion_frecuente_content" *ngIf="dataFrequentOperation">
	<label>Guardar como operación frecuente</label>
	<input type="checkbox" class="toggle_op" [(ngModel)]="dataFrequentOperation.isSelected" (change)="changeToggle()" />
	<input
		type="text"
		class="form_element"
		placeholder="Escriba un nombre"
		[ngStyle]="{ display: dataFrequentOperation.isSelected ? 'inline-block' : '' }"
		maxlength="42"
		[minLength]="minlength"
		alphanumeric
		[(ngModel)]="dataFrequentOperation.nameFrequentOperation"
		(change)="changeFrequentOperation()"
	/>
</div>
